import { micOffOutline, micOutline, stop } from 'ionicons/icons';
import type { PointerEventHandler } from 'react';
import IonIcon from '../../components/IonIcon';

interface Props {
  isRecording: boolean;
  remainingSeconds: number | null;
  disabled?: boolean;
  onPointerDown: PointerEventHandler<HTMLButtonElement>;
  onPointerUp: PointerEventHandler<HTMLButtonElement>;
  onPointerCancel: PointerEventHandler<HTMLButtonElement>;
}

/** Dashed 64px tile — same footprint as the add-photo control. */
export default function DictationTile({
  isRecording,
  remainingSeconds,
  disabled,
  onPointerDown,
  onPointerUp,
  onPointerCancel,
}: Props) {
  const label = isRecording
    ? 'Stop dictation'
    : 'Hold to speak, or tap for hands-free';
  const icon = isRecording ? stop : disabled ? micOffOutline : micOutline;
  const showCountdown = isRecording && typeof remainingSeconds === 'number';

  return (
    <button
      type="button"
      disabled={disabled}
      aria-label={label}
      aria-pressed={isRecording}
      onPointerDown={onPointerDown}
      onPointerUp={onPointerUp}
      onPointerCancel={onPointerCancel}
      onClick={(event) => {
        event.preventDefault();
        event.stopPropagation();
      }}
      className={`relative flex size-16 items-center justify-center rounded-[5px] border-2 border-dashed bg-x9-paper select-none touch-none ${
        isRecording
          ? 'border-x9-marine text-x9-marine'
          : disabled
            ? 'border-x9-mute text-x9-mute opacity-45'
            : 'border-x9-mute text-x9-marineSoft'
      }`}
    >
      <IonIcon icon={icon} size={28} filled={isRecording} />
      {showCountdown ? (
        <span className="absolute bottom-0.5 text-[10px] font-semibold tabular-nums">
          {remainingSeconds}
        </span>
      ) : null}
    </button>
  );
}
